import { Dropdown, Modal, Tooltip } from "antd";
import {
  FileExcelOutlined,
  FilePptOutlined,
  FileWordOutlined,
  PaperClipOutlined,
  PlayCircleFilled,
  AudioOutlined,
  FolderOutlined,
  FileImageOutlined,
  FileZipOutlined,
} from "@ant-design/icons";
import { DocImgBaseUrl, execess_url, execess_url_down } from "../../utils/configurable";
import ZipFile from "../../assets/img/zipFile.png";
import PdfFile from "../../assets/img/pdfFile.png";
import unlockIcon from "../../assets/img/unlock.png";
import lockIcon from "../../assets/img/locknew.jpeg";
import useBreadcrumb from "../../hooks/breadcrumb/useBreadcrumb";
import useFindSelectedNode from "../../hooks/findSelectedNode/useFindSelectedNode";
import useCheckParentKeyExist from "../../hooks/checkParentKey/useCheckParentKeyExist";
import JSZip from "jszip";
import useDocumentViewer from "../../hooks/documentPreview/useDocumentPreview";
import { useFetch } from "../../Services/useFetch";

const RightBrief = ({
  node,
  isLastElement,
  setSelectedKey,
  combinedResponse,
  setBreadcrumb,
  setSelectedNodeData,
  setResetNodeData,
  setShowInnerFolder,
  expandedKeys,
  setExpandedKeys,
  handleDeleteModal,
  handleRenameFolder,
  selectedType,
  selectedItems,
  setDownloading,
  setDownloadingProgress,
  handleMoveFiles,
  handleShareFiles,
  handleLockFolder,
  setLockOpen,
  setProtectedSlug,
  setProtectedLockData,
  socket,
  userInfo,
}) => {
  const { request } = useFetch();
  const { handleBreadcrumb } = useBreadcrumb();
  const { findSelectedNode } = useFindSelectedNode();
  const { checkParentKeyExist } = useCheckParentKeyExist(expandedKeys, combinedResponse);
  const { isModalPreview, setIsModalPreview, onFilterDocClick } = useDocumentViewer();

  const unlocked = JSON.parse(sessionStorage.getItem("unlockedFolders") || "[]");
  const isUnlocked = unlocked.includes(node?.key);

  const onItemClick = () => {
    if (node?.is_locked == 1 || isUnlocked) {
      if (node.document_file_name) {
        return;
      }
      setSelectedKey(node?.key);
      const selectedNodeDatas = findSelectedNode(combinedResponse, node?.key);
      setSelectedNodeData(selectedNodeDatas[0]);
      setResetNodeData(selectedNodeDatas[0]);
      const breadcrumbs = handleBreadcrumb(node, combinedResponse);
      setBreadcrumb(breadcrumbs);
      setShowInnerFolder(true);
      const expandkey = checkParentKeyExist(node);
      setExpandedKeys(expandkey);
      socket.emit("join-folder", {
        folderId: node?.key,
        userId: userInfo?.id,
        userName: userInfo?.userfullname,
      });
    } else {
      setLockOpen(true);
      setProtectedLockData(node);
      setProtectedSlug("unlock");
    }
  };
  function truncateName(name, maxLength) {
    if (name.length > maxLength) {
      return name.slice(0, maxLength) + "...";
    }
    return name;
  }

  const onDocClick = (node) => {
    const imageAndVideoFormats = ["png", "jpeg", ".jpg", "webp", "MP4", "mp4", "mov", "MOV", "webm"];
    const officeFormats = [".xlsx", ".xls", ".pptx", ".ppt", ".csv", ".doc", ".docx"];
    const baseUrl = execess_url.endsWith("/") ? execess_url.slice(0, -1) : execess_url;
    const fileUrl = `${baseUrl}/${node.document_file_path}`;

    if (imageAndVideoFormats.includes(node.title.toLowerCase())) {
      window.open(fileUrl, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=500,width=800,height=800");
    } else if (officeFormats.includes(node.title)) {
      const encodedUrl = encodeURIComponent(fileUrl);
      const url = `https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`;
      window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=500,width=800,height=800");
    } else if (node.title === ".txt") {
      window.open(fileUrl, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=500,width=800,height=800");
    } else {
      window.open(fileUrl, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=500,width=800,height=800");
    }
  };

  const handleCancelPreview = () => {
    setIsModalPreview(false);
  };

  const documentFileDownload = async (item) => {
    if (!item?.document_file_path) {
      console.error("File path is missing!");
      return;
    }

    setDownloadingProgress(0);
    setDownloading(true);

    const apiUrl = `${execess_url_down}${item.document_file_path}`;
    const fileName = item.document_file_name || apiUrl.split("/").pop();

    try {
      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error("Failed to fetch file");

      const contentLength = response.headers.get("Content-Length");
      if (!contentLength) throw new Error("Cannot determine file size.");

      const totalSize = parseInt(contentLength, 10);
      let loaded = 0;

      const reader = response.body.getReader();
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        loaded += value.length;
        setDownloadingProgress(Math.round((loaded / totalSize) * 100));
      }

      // Convert to Blob and trigger download
      const blobData = new Blob(chunks);
      const fileURL = URL.createObjectURL(blobData);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setDownloading(false);
      setDownloadingProgress(0);
    }
  };

  const downloadFiles = async (selectedItems) => {
    try {
      if (!selectedItems || selectedItems.length === 0) {
        console.log("Please select files to download.");
        return;
      }

      if (selectedItems && selectedItems.type === "file") {
        await documentFileDownload(selectedItems);
        return;
      }

      setDownloading(true);
      setDownloadingProgress(0);

      let totalSize = 0;
      let loadedSize = 0;
      const zip = new JSZip();

      // Fetch folder contents from API
      const fetchFolderItems = async (folderId) => {
        const formData = new URLSearchParams();
        formData.append("folder_id", folderId || "");
        const response = await request("/doctrol-files-list", "post", formData, {
          "Content-Type": "application/x-www-form-urlencoded",
        });
        return response?.data?.status === "1" ? response.data.data : [];
      };

      // Step 1: Calculate total size recursively
      const calculateTotalSize = async (items) => {
        for (const item of items) {
          if (item.type === "file") {
            const apiUrl = `${execess_url_down}${item.document_file_path}`;
            const response = await fetch(apiUrl, { method: "HEAD" });
            const contentLength = response.headers.get("Content-Length");
            if (contentLength) totalSize += parseInt(contentLength, 10);
          } else if (item.type === "folder") {
            const folderItems = await fetchFolderItems(item.key);
            await calculateTotalSize(folderItems);
          }
        }
      };

      await calculateTotalSize(selectedItems);

      const downloadItem = async (item, currentPath = "") => {
        if (item.type === "file" || item.document_file_name) {
          const apiUrl = `${DocImgBaseUrl}${item.document_file_path}`;
          const fileName = item.document_file_name || apiUrl.split("/").pop();
          const fullPath = currentPath ? `${currentPath}/${fileName}` : fileName;

          try {
            const response = await fetch(apiUrl);
            if (!response.ok) throw new Error(`Failed to fetch file: ${fileName}`);

            const reader = response.body.getReader();
            const chunks = [];

            while (true) {
              const { done, value } = await reader.read();
              if (done) break;

              chunks.push(value);
              loadedSize += value.length;
              setDownloadingProgress(Math.round((loadedSize / totalSize) * 100));
            }

            const blobData = new Blob(chunks);
            zip.file(fullPath, blobData); // Maintain folder structure
          } catch (error) {
            console.error("Error downloading file:", error);
          }
        } else if (item.type === "folder" || item.title) {
          const folderPath = currentPath ? `${currentPath}/${item.title}` : item.title;

          // Get a folder reference
          let folderContents;
          if (item?.permissions[0]?.can_access && item?.permissions[0]?.file_download) {
            zip.folder(folderPath);

            const folderItems = await fetchFolderItems(item.key);

            const nestedFolders = Array.isArray(item.children) ? item.children : [];
            folderContents = [...folderItems, ...nestedFolders];
          } else {
            folderContents = [];
          }

          for (const childItem of folderContents) {
            await downloadItem(childItem, folderPath);
          }
        }
      };

      for (const item of selectedItems) {
        await downloadItem(item);
      }

      const zipBlob = await zip.generateAsync({
        type: "blob",
        compression: "STORE",
      });

      const zipUrl = URL.createObjectURL(zipBlob);
      const link = document.createElement("a");
      link.href = zipUrl;
      link.download = `downloaded_files.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(zipUrl);
    } catch (error) {
      console.error("Error downloading multiple files:", error);
    } finally {
      setDownloading(false);
      setDownloadingProgress(0);
    }
  };

  const showDrawer = async (node) => {
    const url = `/editor?fileID=${encodeURIComponent(node?.key)}`;
    window.open(url, "_blank");
    return;
  };

  return (
    <>
      {node?.document_file_name ? (
        <Tooltip>
          <Dropdown
            menu={{
              items:
                selectedItems?.length < 2
                  ? [
                      node?.permissions[0]?.file_view && {
                        label: <b>Open</b>,
                        key: "1",
                        onClick: () =>
                          node.title == ".xls" ||
                          node.title == ".xlsx" ||
                          node.title == ".doc" ||
                          node.title == ".docx" ||
                          node.title == ".ppt" ||
                          node.title == ".pptx" ||
                          node.title == ".pdf"
                            ? showDrawer(node)
                            : onDocClick(node),
                      },
                      node?.permissions[0]?.file_move && {
                        label: "Move",
                        key: "5",
                        onClick: () => handleMoveFiles(node, "move"),
                      },
                      node?.permissions[0]?.file_download && {
                        label: "Download",
                        key: "2",
                        onClick: () => downloadFiles(node),
                      },
                      node?.permissions[0]?.file_delete && {
                        label: "Delete",
                        key: "3",
                        onClick: () => handleDeleteModal(selectedItems.length > 1 ? selectedItems : node),
                      },
                      node?.permissions[0]?.file_rename && {
                        label: "Rename",
                        key: "4",
                        onClick: () => handleRenameFolder(node, "file"),
                      },
                      // node?.permissions[0]?.file_move &&
                      // {
                      //     label: 'Move to',
                      //     key: '5',
                      //     onClick: () => handleMoveFiles(selectedItems.length > 1 ? selectedItems : node, "move"),
                      // },
                      node?.permissions[0]?.file_share && {
                        label: "Share",
                        key: "6",
                        onClick: () => handleShareFiles(selectedItems.length > 1 ? selectedItems : node, "share"),
                      },
                      // (node.title == ".xls" || node.title == ".xlsx" || node.title == ".doc" || node.title == ".docx" || node.title == ".ppt" || node.title == ".pptx" || node.title == ".pdf") && {
                      //     label: 'Edit File',
                      //     key: '7',
                      //     onClick: () => showDrawer(node),
                      // },
                    ].filter(Boolean)
                  : selectedType == "file"
                  ? [
                      node?.permissions[0]?.file_download && {
                        label: "Download",
                        key: "1",
                        onClick: () => downloadFiles(selectedItems),
                      },
                      node?.permissions[0]?.file_delete && {
                        label: "Delete",
                        key: "2",
                        onClick: () => handleDeleteModal(selectedItems.length > 1 ? selectedItems : node),
                      },
                      node?.permissions[0]?.file_move && {
                        label: "Move to",
                        key: "3",
                        onClick: () => handleMoveFiles(selectedItems.length > 1 ? selectedItems : node, "move"),
                      },

                      node?.permissions[0]?.file_share && {
                        label: "Share",
                        key: "4",
                        onClick: () => handleShareFiles(selectedItems.length > 1 ? selectedItems : node, "share"),
                      },
                    ]
                  : [
                      node?.permissions[0]?.file_download && {
                        label: "Download",
                        key: "2",
                        onClick: () => downloadFiles(selectedItems),
                      },
                      node?.permissions[0]?.file_delete && {
                        label: "Delete",
                        key: "1",
                        onClick: () => handleDeleteModal(selectedItems.length > 1 ? selectedItems : node),
                      },
                       node?.permissions[0]?.file_move && {
                        label: "Move",
                        key: "3 ",
                        onClick: () => handleMoveFiles(node, "move"),
                      },
                    ],
            }}
            trigger={["contextMenu"]}
            getPopupContainer={() => document.getElementById("zoom")}
          >
            <div
              className="ib_item"
              // contentEditable="true"
              // onContextMenu={(e) => {
              //     handleItemClick(e, node); // 👈 Custom function call
              // }}
              onKeyDown={(e) => e.preventDefault()}
            >
              <div
                className="imgCase"
                id={isLastElement ? "imgCaseId" : ""}
                onDoubleClick={() =>
                  node.title == ".xls" ||
                  node.title == ".xlsx" ||
                  node.title == ".doc" ||
                  node.title == ".docx" ||
                  node.title == ".ppt" ||
                  node.title == ".pptx" ||
                  node.title == ".pdf"
                    ? showDrawer(node)
                    : onFilterDocClick(node)
                }
              >
                {(() => {
                  const filePath = node?.document_file_path || "";
                  const fileExtension = filePath.split(".").pop().toLowerCase();
                  const fileUrl = `${DocImgBaseUrl}${filePath}`;
                  const thumbnailUrl = `${DocImgBaseUrl}${node?.document_file_path}`;
                  switch (fileExtension) {
                    case "mp4":
                    case "webm":
                    case "ogg":
                      return (
                        <>
                          {/* <PlayCircleFilled className="ant_icons" style={{ color: "red" }} /> */}
                          <video src={fileUrl} controls />
                        </>
                      );
                    case "mp3":
                    case "wav":
                      return (
                        <div clasName="download_icon">
                          <AudioOutlined className="ant_icons" />
                          <audio src={fileUrl} style={{ width: "100%", marginTop: "10px" }} />
                        </div>
                      );
                    case "png":
                    case "jpg":
                    case "jpeg":
                    case "gif":
                    case "bmp":
                    case "webp":
                      return <img src={thumbnailUrl} alt="img" />;
                    case "pdf":
                      return (
                        <div className="ant_icons" style={{ textAlign: "center", alignItems: "center" }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-file-earmark-pdf"
                            viewBox="0 0 16 16"
                          >
                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                            <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                          </svg>
                        </div>
                      );
                    case "doc":
                    case "docx":
                      return (
                        <div className="download_icon">
                          <FileWordOutlined className="ant_icons" />
                        </div>
                      );
                    case "zip":
                    case "rar":
                      return (
                        <div className="download_icon">
                          <FileZipOutlined className="ant_icons" />
                        </div>
                      );
                    // ✅ Separate case for Excel
                    case "xls":
                    case "xlsx":
                      return (
                        <div className="download_icon">
                          <FileExcelOutlined className="ant_icons" />
                        </div>
                      );

                    // ✅ Separate case for PowerPoint
                    case "ppt":
                    case "pptx":
                      return (
                        <div className="download_icon">
                          <FilePptOutlined className="ant_icons" />
                        </div>
                      );
                    default:
                      return (
                        <div className="download_icon">
                          <PaperClipOutlined className="ant_icons" />
                        </div>
                      );
                  }
                })()}
              </div>
              <div className="fileName_text">{truncateName(node?.document_title, 15)}</div>
            </div>
          </Dropdown>
        </Tooltip>
      ) : (
        <Tooltip>
          <Dropdown
            menu={{
              items:
                selectedItems?.length < 2
                  ? [
                      (node?.is_locked == 1 || isUnlocked) &&
                        node?.permissions[0]?.can_delete && {
                          label: "Delete",
                          key: "1",
                          onClick: () => handleDeleteModal(selectedItems.length > 1 ? selectedItems : node),
                        },
                      (node?.is_locked == 1 || isUnlocked) &&
                        node?.permissions[0]?.can_rename && {
                          label: "Rename",
                          key: "2",
                          onClick: () => handleRenameFolder(node, "folder"),
                        },
                      node?.is_locked == 1 &&
                        node?.permissions[0]?.can_lock && {
                          label: "Lock Folder",
                          key: "3",
                          onClick: () => handleLockFolder(node, "lock"),
                        },
                      node?.is_locked !== 1 &&
                        !isUnlocked &&
                        node?.permissions[0]?.can_unlock && {
                          label: "Unlock Folder",
                          key: "4",
                          onClick: () => handleLockFolder(node, "unlock"),
                        },
                      node?.permissions[0]?.file_move && {
                        label: "Move",
                        key: "5",
                        onClick: () => handleMoveFiles(node, "move"),
                      },
                      node?.permissions[0]?.file_download && {
                        label: "Download",
                        key: "6",
                        onClick: () => downloadFiles([node]),
                      },
                    ].filter(Boolean)
                  : selectedType == "both" || selectedType == "folder"
                  ? [
                      node?.permissions[0]?.can_delete && {
                        label: "Delete",
                        key: "1",
                        onClick: () => handleDeleteModal(selectedItems.length > 1 ? selectedItems : node),
                      },
                      node?.permissions[0]?.file_move && {
                        label: "Move",
                        key: "2",
                        onClick: () => handleMoveFiles(selectedItems.length > 1 ? selectedItems : node, "move"),
                      },
                      node?.permissions[0]?.file_download && {
                        label: "Download",
                        key: "3",
                        onClick: () => downloadFiles(selectedItems.length > 1 ? selectedItems : node),
                      },
                    ]
                  : [],
            }}
            trigger={["contextMenu"]}
            getPopupContainer={() => document.getElementById("zoom")}
          >
            <div className="ib_item" onDoubleClick={onItemClick} onKeyDown={(e) => e.preventDefault()}>
              {node?.is_locked == 0 && isUnlocked ? (
                <img className="folder_img" src={unlockIcon} width={55} alt="" loading="lazy" />
              ) : node?.is_locked == 0 && !isUnlocked ? (
                <img className="folder_img" src={lockIcon} width={55} alt="" loading="lazy" />
              ) : (
                <>
                  <FolderOutlined className="right_icons" style={{ color: "rgb(59 130 246)" }} />
                </>
              )}
              <div className="fileName_text">{truncateName(node.title, 15)}</div>
            </div>
          </Dropdown>
        </Tooltip>
      )}
      {isModalPreview && (
        <Modal title={node.document_title} open={isModalPreview} onCancel={handleCancelPreview} footer={null}>
          {(() => {
            const filePath = node?.document_file_path || "";
            const fileExtension = filePath.split(".").pop().toLowerCase();
            const fileUrl = `${DocImgBaseUrl}${filePath}`;

            switch (fileExtension) {
              case "mp4":
              case "webm":
              case "ogg":
                return (
                  <div style={{ textAlign: "center" }}>
                    <PlayCircleFilled style={{ fontSize: "32px", color: "#1890ff" }} />
                    <video src={fileUrl} controls style={{ width: "100%", marginTop: "10px" }} />
                  </div>
                );
              case "mp3":
              case "wav":
                return (
                  <div style={{ textAlign: "center" }}>
                    <AudioOutlined style={{ fontSize: "24px", color: "#1890ff" }} />
                    <audio src={fileUrl} controls style={{ width: "100%", marginTop: "10px" }} />
                  </div>
                );
              case "png":
              case "jpg":
              case "jpeg":
              case "gif":
              case "bmp":
              case "webp":
                return <img src={fileUrl} alt={node.title} style={{ maxWidth: "100%" }} loading="lazy" />;
              case "pdf":
                return (
                  <div style={{ textAlign: "center" }}>
                    <img src={PdfFile} alt={"pdf File"} loading="lazy" />
                  </div>
                );
              case "doc":
              case "docx":
                return (
                  <div style={{ textAlign: "center" }}>
                    <FileWordOutlined style={{ fontSize: "24px", color: "#1890ff" }} />
                    <a href={fileUrl} download={node?.document_file_name}>
                      Download Document
                    </a>
                  </div>
                );
              case "zip":
              case "rar":
                return (
                  <div style={{ textAlign: "center" }}>
                    <img src={ZipFile} alt={"pdf File"} loading="lazy" />
                  </div>
                );
              default:
                return (
                  <div style={{ textAlign: "center" }}>
                    <PaperClipOutlined style={{ fontSize: "24px", color: "#bfbfbf" }} />
                    <a
                      href={fileUrl}
                      download={node?.document_file_name}
                      style={{
                        marginTop: "10px",
                        display: "inline-block",
                        textDecoration: "none",
                      }}
                    >
                      Download File
                    </a>
                  </div>
                );
            }
          })()}
        </Modal>
      )}
    </>
  );
};

export default RightBrief;
